import Vue from 'vue';

class Form {

    constructor(data, snotify) {
        this.originalData = JSON.parse(JSON.stringify(data));

        if (snotify === undefined || snotify === null) {
            this.snotify = Vue.prototype.$snotify;
        } else {
            this.snotify = snotify;
        }

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }
    
    data() {
        let data = new FormData();

        for (let property in this.originalData) {

            if (this[property] instanceof Array) {
                let arr = [];

                for (let obj in this[property]) {

                    if (property === 'files') {
                        let file = this[property][obj];
                        data.append('files[]', file);
                        continue;
                    }

                    arr.push(this[property][obj]);
                }

                if (property !== 'files') {
                    data.append(property, JSON.stringify(arr));
                    continue;
                }

            } else if (this[property] instanceof Object) {
                data.append(property, JSON.stringify(this[property]));
                continue;
            }

            if (property !== 'files') {
                data.append(property, this[property]);
            }

        }

        return data;
    }

    propertiesHaveData(properties) {

        for (var index in properties) {
            let property = properties[index];
            let data = this.data();

            if (!data.hasOwnProperty(property)) {
                return false;
            }

            if (data[property] instanceof Array && data[property].length === 0) {
                return false;
            }

            if (!data[property]) {
                return false;
            }
        }

        return true;
    }

    async reset() {
        for (let field in this.originalData) {
            this[field] = null;
        }

        this.errors.clear();
    }

    resetToDefault() {
        for (let field in this.originalData) {
            this[field] = _.cloneDeep(this.originalData[field]);
        }

        this.errors.clear();
    }

    get(url, headers) {
        return this.submit('get', url, headers);
    }

    post(url, headers) {
        return this.submit('post', url, headers);
    }

    put(url) {
        this.addMethod('put');
        return this.submit('post', url);
    }

    patch(url) {
        this.addMethod('patch');
        return this.submit('post', url);
    }

    delete(url) {
        return this.submit('delete', url);
    }

    clearSnotify()
    {
        this.snotify.clear();
    }

    submit(requestType, url, headers) {
        return new Promise((resolve, reject) => {
            this.snotify.async('Submitting...', 'Please wait', () => new Promise((snotifyResolve, snotifyReject) => {
                axios[requestType](url, this.data(), { headers: headers ? headers : {}})
                    .then(response => {
                        this.removeMethod();
                        this.onSuccess(response.data);

                        snotifyResolve(
                            {
                                'title': 'Success',
                                'body': 'Your request was successfully submitted.',
                                config: {
                                    timeout: 2000,
                                    closeOnClick: true
                                }
                            }
                        );

                        resolve(response.data);
                    })
                    .catch(error => {
                        if (error.response && (error.response.status === 419 || error.response.status === 401)) {
                            window.location.replace(route('login'));
                        }

                        this.removeMethod();
                        snotifyReject({
                            title: 'We got an error!',
                            body: this.onFail(error),
                            config: {
                                timeout: 2000,
                                closeOnClick: true
                            }
                        });

                        reject(error);
                    });
            }));
        });
    }

    onSuccess() {
    }

    onFail(error) {
        if (error.response) {
            this.errors.add(error.response.data.errors);
        }

        if (error.response && error.response.data) {
            return error.response.data.message;
        }

        return 'Your request failed for an unknown reason.'
    }

    addMethod(method) {
        this.originalData['_method'] = method.toUpperCase();
        this['_method'] = method.toUpperCase();
    }

    removeMethod() {
        delete this.originalData['_method'];
        delete this['_method'];
    }
}

export default Form;



// WEBPACK FOOTER //
// ./resources/assets/js/core/form.js